window.addEventListener('DOMContentLoaded', () => {
  $(document).on('click', '.checkBox', function() {
    if($(this).is('.additionCheckYes:checked')) {
      $('.additionalFields').slideDown(300);
    }
    else if($(this).is('.additionCheckNo:checked')) {
      $('.additionalFields').slideUp(300);
    }
    else if($(this).is('.extendCheckYes:checked')) {
      $('.extendedForm').slideDown(300);
      $('.registerBtnWrap').slideDown(300);
    }
    else if($(this).is('.extendCheckNo:checked')) {
      $('.extendedForm').slideUp(300);
      $('.registerBtnWrap').slideDown(300);
    }
    else {
    }
  });

  $('#productRegistrationForm').on('submit', function(e) {
    e.preventDefault();
   $('.loaderWrap').show();
    var currWindowPos = $(window).scrollTop();
    var tobeScroll = currWindowPos+200;
    //$('input[name=is_addition_register]:checked').val(1);
    //$('input[name=is_ask_more]:checked').val(1);
  
   if ($('#date_of_purchase').val() == '' || $('#date_of_purchase').val() == 0) {
     $('.loaderWrap').hide();
     $('.buttonInfoGrid').find('.repairErrorMsg').remove();
     $('.buttonInfoGrid').append('<p class="repairErrorMsg">Please select a date</p>');
     $('html,body').animate({'scrollTop':tobeScroll},300);
     setTimeout(function() {
       $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
     },3000);
   }
   else if ($('#style_num').val() == '' || $('#style_num').val() == 0) {
     $('.loaderWrap').hide();
     $('.buttonInfoGrid').find('.repairErrorMsg').remove();
     $('.buttonInfoGrid').append('<p class="repairErrorMsg">Please enter Style Number</p>');
     $('html,body').animate({'scrollTop':tobeScroll},300);
     setTimeout(function() {
       $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
     },3000);
   }
   else if ($('#serial_num').val() == '' || $('#serial_num').val() == 0) {
     $('.loaderWrap').hide();
     $('.buttonInfoGrid').find('.repairErrorMsg').remove();
     $('.buttonInfoGrid').append('<p class="repairErrorMsg">Please enter Serial Number</p>');
     $('html,body').animate({'scrollTop':tobeScroll},300);
     setTimeout(function() {
       $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
     },3000);
   }
   else {
     var form_data = jQuery("#productRegistrationForm").serialize();
     var dateVal = $('#productRegistrationForm').val();
     $.ajax({
       data: form_data,
       url: "https://productreg.briggs-riley.com/api/registration",
       method: "POST",
       dataType: "json",
       success: function(response){
         var statusCode = response.status;
         if(statusCode == true || statusCode == 200) {
           console.log('***********');
           console.log(response.status);
           window.location.href= "/account";
         }
         else {
           $('.loaderWrap').hide();
           $('.buttonInfoGrid').append('<p class="repairMsg">'+response.message+'</p>');
           $('html,body').animate({'scrollTop':tobeScroll},300);
           setTimeout(function() {
             $('.buttonInfoGrid').find('.repairMsg').fadeOut(300);
           },3000);
         }
  
       },
       error: function (response) {
         $('.loaderWrap').hide();
         console.log(response.data);
         $('.buttonInfoGrid').append('<p class="repairErrorMsg">'+response.responseJSON.message+'</p>');
         $('html,body').animate({'scrollTop':tobeScroll},300);
         setTimeout(function() {
           $('.buttonInfoGrid').find('.repairErrorMsg').fadeOut(300);
         },3000);
         console.log("=======");
         console.log(response);
       }
  
     });
  
   }
  });
})
